import { __exports as build } from '../../_virtual/index.js';
export { __exports as default } from '../../_virtual/index.js';
Object.defineProperty(build, '__esModule', {
  value: true
});
var attributes = {
  borderRadius: {
    extraSmall: 2,
    small: 5,
    default: 10,
    big: 20,
    rounded: 100,
    circle: '50%'
  },
  boxShadow: {
    small: '0 0 46px 0 rgba(0, 0, 0, 0.13)',
    hover: '0 0 15px 0 rgba(0, 0, 0, 0.13)',
    buttonHover: '0 1px 5px rgba(0, 0, 0, 0.35)',
    buttonActive: 'inset 0 0px 5px rgba(0, 0, 0, 0.15)',
    iconButtonHover: '0 1px 8px rgba(0, 0, 0, 0.35)',
    layoutShadow: '0 1px 0 rgba(0, 0, 0, 0.15)',
    layoutShadowInset: 'inset 0 -1px 0 rgba(0, 0, 0, 0.15)',
    layoutShadowInsetMedium: 'inset 0 -2px 0 rgba(0, 0, 0, 0.15)',
    stepperShadow: '0px -5px 20px rgba(0, 0, 0, 0.04), 0px -2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    highlightBoxShadow: '0 2px 5px 0 rgba(7,52,99,0.15)'
  },
  zIndex: {
    modal: 5,
    footer: 4,
    high: 3,
    middle: 2,
    low: 1
  },
  transition: {
    t1: '550ms cubic-bezier(0.19, 1, 0.22, 1)',
    inputTransition: 'box-shadow 250ms ease'
  }
};
var breakpoints = {
  xxs: 360,
  xs: 480,
  sm: 576,
  md: 768,
  lg: 960,
  xl: 1060,
  xxl: 1280,
  xxxl: 1400
};
var constants = {
  headerScrollFadeRange: 50,
  modalContainerMaxWidth: 615,
  modalConfirmMaxWidth: 480,
  pageContainerMaxWidth: 776,
  twoColumnsContainerMaxWidth: 1024,
  deliverySlotItemWidth: 130,
  deliverySlotItemWidthDesktop: 146,
  deliverySlotItemHeight: 91,
  deliverySlotArrowOffset: 42,
  itemGap: 2,
  listImageMaxWidth: 64,
  listImageMaxHeight: 50,
  listImageMaxWidthSmall: 32,
  listImageMaxHeightSmall: 32,
  listItemFlexGap: 20,
  infoBlockImageMaxWidthDesktop: 100,
  chipCheckBox: 12,
  pageContentMaxWidth: 1232,
  infoBlockBorderWidth: 4,
  tableRowVerticalPadding: 16,
  tableRowHorizontalPadding: 14,
  tableHeaderVerticalPadding: 12,
  menuHorizontalMargin: 12,
  headerWrapperVerticalPadding: 20,
  iconToolTipArrowLeft: 2.5,
  iconToolTipArrowTop: 32,
  iconToolTipBoxWidth: 300,
  iconToolTipTop: 36,
  dateBoxHorizontalPadding: 12,
  BackgroundOverlayOpacity: 0.3,
  selectWidth: 225,
  selectMobileWidth: 175,
  selectPadding: 2,
  cartListItemDescriptionSize: 11,
  mobileTablePadding: 12,
  mobileTablePaddingBottom: 6,
  mobileLabelVerticalPadding: 10,
  mobileLabelPaddingRight: 35,
  mobileLabelVerticalPaddingMobile: 8,
  mobileLabelPaddingRightMobile: 20,
  menuListItemIconSize: 16,
  priceIndicatorRotate: 1,
  priceRotate: 2.5,
  priceSplashHorizontalPadding: 10,
  priceVariantBadgeSize: 48,
  buttonWrapperMinWidth: 120,
  buttonChildGap: 12,
  buttonChildSmallGap: 8,
  buttonChildExtraSmallGap: 4,
  buttonBadgeTopPosition: -3,
  buttonBadgeRightPosition: -4,
  buttonBadgePadding: 6,
  buttonBadgePaddingSmall: 2,
  buttonBadgeFontSize: 11,
  navHeaderHeight: 81,
  navHeaderHeightSmall: 64,
  searchModalZIndex: 900,
  searchBarHorizontalPadding: 12,
  headerBreakpoint: 991,
  zipCodeInputSize: 48,
  zipCodeInputSizeSmall: 40,
  tooltipMinWidth: 80,
  toolTipTop: 35,
  toolTipArrowMarginTop: -5,
  toolTipBackground: 'rgba(0,0,0,.7)',
  toolTipArrowBorderWidth: 5,
  searchListItemGridTemplateColumns: 25,
  MarkingWrapperGridGap: 2,
  InputWithIconPaddingRight: 45,
  navMainLinkWidth: 105,
  maxHeightFaderHeight: 50,
  paginationButtonWidth: 44,
  cartCardImageSize: 48,
  toolTipCloseSize: 20,
  couponContainerHeight: 43,
  couponButtonContainer: 102,
  couponContainerPadding: 10,
  selectButtonWidth: 169,
  quantitySelectorWidthLarge: 140,
  quantitySelectorWidthSmall: 123,
  priceBaseLetterSpacing: -0.03
};
var palette = {
  // pallette same as brand colors
  primary: '#FFDF43',
  secondary: '#0071B9',
  // brand colors
  brandYellow: '#FFDF43',
  brandBlue: '#0071B9',
  brandPurple: '#A71680',
  brandPrio: '#a80073',
  // shades
  yellowLighter: '#FFFBE7',
  yellowLight: '#FFF7D1',
  blueLight: '#ECF7FE',
  blueLighter: '#D3EDFD',
  blueMedium: '#92B9D3',
  greenLight: '#F2FDF2',
  greenMedium: '#BEE5BE',
  redLight: '#FCE9E9',
  priceTagRed: '#C80700',
  // recipeTags
  recipeVego: '#65DB69',
  recipeLactose: '#8CCDF0',
  recipeGluten: '#D5642A',
  // link same as alert blue
  link: '#0072BB',
  // black / white
  white: '#FFFFFF',
  black: '#000000',
  // grayscale
  lightest: '#F7F7F7',
  lighter: '#F1F1F1',
  light: '#E8E8E8',
  medium: '#DBDBDB',
  mediumDark: '#6C6C6C',
  dark: '#979797',
  darker: '#4A4A4A',
  darkest: '#333333',
  buttonGray: '#E5E4E5',
  disabledGray: '#B8B8B8',
  disabledDarkGray: '#5c5c5c',
  placeholder: '#8f8f8f',
  border: '#0069AE',
  boxShadow: '#E1E1E1',
  boxShadowActive: 'rgba(7, 52, 99, 0.15)',
  // Alerts
  alertRed: '#E02721',
  alertBlue: '#0072BB',
  alertGreen: '#3F9A3C',
  // overlay
  darkOverlay: 'rgba(0, 0, 0, 0.6)',
  // transparent
  transparent: '#ffffff00',
  // hover
  brandBlueHover: '#005C99',
  brandYellowHover: '#F5D800',
  brandPrioHover: '#90136F',
  brandBlueActive: '#004D80',
  brandYellowActive: '#DBC100',
  brandPrioActive: '#7A105E',
  none: 'none'
};
var spacings = {
  xxxs: 2,
  xxs: 4,
  xxs2: 6,
  xs: 8,
  xs1: 10,
  xs2: 12,
  xs3: 14,
  sm: 16,
  sm2: 20,
  md: 24,
  lg: 32,
  xl: 40,
  xl2: 48,
  xxl: 56 // More in figma, but talk with Johan to generalize it more.
  // xxx: 72, 88, 120, 152 ?

};
var typography = {
  type: {
    primary: '"Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif',
    display: '"Dom Casual"',
    code: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace'
  },
  weight: {
    regular: '400',
    medium: '500',
    semiBold: '600',
    bold: '700',
    extraBold: '800'
  },
  size: {
    // xs all from 0-10
    xs: 10,
    // s all from 11-20
    s0: 11,
    s1: 12,
    s2: 13,
    s3: 15,
    s4: 18,
    // m all from 21-40
    m1: 24,
    m2: 30,
    // l all from 41 >
    l1: 41,
    code: 90
  },
  lineHeight: {
    // xs all from 0-15
    xs: 15,
    // s all from 16-20
    s1: 18,
    s2: 19,
    // m all from 21-40
    m1: 22,
    m2: 27,
    m3: 36,
    // l all from 41 >
    l1: 45
  }
};
var animations = {
  tapScale: 0.9,
  hoverScale: 1.1,
  buttonTransition: 'all 250ms cubic-bezier(0.165, 0.84, 0.44, 1)',
  rippleTransition: '750ms cubic-bezier(0.19, 1, 0.22, 1)',
  saveButtonAnimationComplete: 600
};

var createTheme = function createTheme(_a) {
  var palette = _a.palette,
      typography = _a.typography,
      attributes = _a.attributes,
      breakpoints = _a.breakpoints,
      spacings = _a.spacings,
      constants = _a.constants,
      animations = _a.animations;
  return {
    palette: palette,
    typography: typography,
    attributes: attributes,
    breakpoints: breakpoints,
    spacings: spacings,
    constants: constants,
    animations: animations
  };
};

var theme = createTheme({
  palette: palette,
  typography: typography,
  attributes: attributes,
  breakpoints: breakpoints,
  spacings: spacings,
  constants: constants,
  animations: animations
});
build.animations = animations;
build.attributes = attributes;
build.breakpoints = breakpoints;
build.constants = constants;
build.palette = palette;
build.spacings = spacings;
var theme_1 = build.theme = theme;
build.typography = typography;
export { theme_1 as theme };